import React from 'react';
import type { CSSProperties } from 'react';
import PropTypes from 'prop-types';
import { NumberInputBase } from 'innovatint_base/components/NumberInputBase';

type CommonNumberInputProps = {
  id?: string;
  className?: string;
  style?: CSSProperties;
  disabled?: boolean;
  readOnly?: boolean;
  value: number | null;
  min?: number;
  max?: number;
  step?: number;
  deferChange?: boolean;
  decimals?: number;
  dataTestid?: string;
};

export type NumberInputProps = CommonNumberInputProps &
  (
    | {
        emptyIsNull: true;
        onChange: (value: number | null) => void;
      }
    | {
        emptyIsNull?: false;
        onChange: (value: number) => void;
      }
  );

function NumberInput(props: NumberInputProps): React.ReactElement {
  const {
    id,
    className,
    style,
    disabled,
    readOnly,
    value,
    emptyIsNull,
    min,
    max,
    step = 1,
    deferChange,
    decimals = 6,
    dataTestid,
  } = props;
  const handleChange = (newValue: number | null): void => {
    if (props.emptyIsNull) {
      props.onChange(newValue);
    } else {
      props.onChange(newValue ?? 0);
    }
  };

  return (
    <NumberInputBase
      renderInput={(props) => (
        <input
          id={id}
          data-testid={dataTestid}
          type="text"
          autoComplete="off"
          className={className}
          style={style}
          disabled={disabled}
          readOnly={readOnly}
          {...props}
        />
      )}
      value={value}
      emptyIsNull={emptyIsNull}
      min={min}
      max={max}
      step={step}
      onChange={!deferChange ? handleChange : undefined}
      updateOnBlur={deferChange ? handleChange : undefined}
      decimals={decimals}
    />
  );
}

NumberInput.propTypes = {
  id: PropTypes.string,
  className: PropTypes.any,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  value: PropTypes.number,
  emptyIsNull: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  deferChange: PropTypes.bool,
  decimals: PropTypes.number,
  dataTestid: PropTypes.string,
};

export default NumberInput;
